import { createStore } from 'owa-satcheljs';
import type DrawerPaneState from './schema/DrawerPaneState';

const defaultStore: DrawerPaneState = {
    activePanes: new Map<string, string>(),
};

export const getStore: () => DrawerPaneState = createStore<DrawerPaneState>(
    'DrawerPaneStore',
    defaultStore
);
